import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  listaAtendimentos: [],
  atendimentoPesquisa: {
    id: 0,
  },
  labelQuantidade: '',
  atendimentoSelecionado: {
    id: 0,
    estagio: "PRE_CADASTRO",
    status: "EM_ESPERA",
    formaAtendimento: "TELEFONE",
    operacao: "VENDA",
    area: 0,
    valorInicial: undefined,
    valorFinal: undefined,
    cliente: {
      id: 0,
      personalidadeJuridica: "PESSOA_FISICA"
    },
    usuario: { id: 0 },
    estado: { id: 0},
    cidade: { id: 0 },
    tipoImovel: { id: 0 },
    bairros: [],
    imoveisSemelhantes: []
  },
  estagioAtualNavegacao: 'PRE_CADASTRO',
  listaClientesSelect: [],
  propostaConcluida: {}
}

const mutations = {
  novoAtendimento(state) {
    state.atendimentoSelecionado = {
      id: 0,
      estagio: "PRE_CADASTRO",
      status: "EM_ESPERA",
      formaAtendimento: "TELEFONE",
      operacao: "VENDA",
      area: 0,
      valorInicial: undefined,
      valorFinal: undefined,
      cliente: {
        id: 0,
        personalidadeJuridica: "PESSOA_FISICA"
      },
      usuario: { id: 0 },
      estado: { id: 0},
      cidade: { id: 0 },
      tipoImovel: { id: 0 },
      bairros: [],
      imoveisSemelhantes: []
    }
    state.estagioAtualNavegacao = 'PRE_CADASTRO'
  },
  limparAtendimentosListados(state) {
    state.listaAtendimentos = [];
  },
  atualizarAtendimentosListados(state, payload) {
    state.listaAtendimentos = payload.lista;
    state.labelQuantidade = payload.quantidade + (payload.quantidade == 1 ? " imóvel encontrado" : " imóveis encontrados");
  },
  atualizarAtendimentoSelecionado(state, payload) {
    state.atendimentoSelecionado = payload;
    state.estagioAtualNavegacao = payload.estagio
  },
  atualizarEstagioAtualNavegacao(state, payload) {
    state.estagioAtualNavegacao = payload;
  },
  atualizarListaClientesSelect(state, payload) {
    state.listaClientesSelect = payload;
  },

  atualizarPropostaAguardandoAssinatura(state, payload) {
    const propostaAguardandoAssinatura = payload.find(item => {
      if(item.acao === 'AGUARDANDO_ASSINATURA') {
        return item;
      }
    });

    if(propostaAguardandoAssinatura) {
      state.propostaAguardandoAssinatura = propostaAguardandoAssinatura;
    } else {
      state.propostaAguardandoAssinatura = {}
    }
  },
  atualizarPropostaConcluida(state, payload) {
    const propostaDeConclusao = payload.find(item => {
      if(item.acao === 'FINALIZAR') {
        return item;
      }
    });

    if(propostaDeConclusao) {
      state.propostaConcluida = propostaDeConclusao;
    } else {
      state.propostaConcluida = {}
    }
  },
  limparPesquisa(state) {
    state.atendimentoPesquisa = {
      id: 0,
    }
  },

  atualizarListaPropostaCancelada(state, index) {
    state.atendimentoSelecionado.propostas[index].acao = 'CANCELADO'
  }
}

const actions = {
  novoAtendimento(context) {
    context.commit('novoAtendimento');
  },
  limparPesquisa(context) {
    context.commit('limparPesquisa')
  },
  listarAtendimentos(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentosListados', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarAtendimentos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      context.commit('limparAtendimentosListados');
      throw error;
    });
  },
  recuperarAtendimento(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item)
         // context.commit('atualizarPropostaAguardandoAssinatura', response.data.item.propostas)
          context.commit('atualizarPropostaConcluida', response.data.item.propostas)
          return response.data;
        case "SESSAO_EXPIRADA":
        return context.dispatch('loginStore/relogar', {}, { root: true })
        .then(authResponse => {
          if(authResponse.status == "SUCESSO") {
            return context.dispatch('recuperarAtendimento', payload);
          }
        }).catch((error) => {
          throw error;
        });
      default:
        return response.data;
      }
    }).catch((error) => {
      context.dispatch('novoAtendimento');
      throw error;
    });
  },
  concluirPreCadastroAtendimento(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_CONCLUIR_PRE_CADASTRO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item)
          return response.data;
        case "SESSAO_EXPIRADA":
        return context.dispatch('loginStore/relogar', {}, { root: true })
        .then(authResponse => {
          if(authResponse.status == "SUCESSO") {
            return context.dispatch('concluirPreCadastroAtendimento', payload);
          }
        }).catch((error) => {
          throw error;
        });
      default:
        return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  concluirCriacaoPerfilAtendimento(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_CONCLUIR_CRIACAO_PERFIL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item)
          return response.data;
        case "SESSAO_EXPIRADA":
        return context.dispatch('loginStore/relogar', {}, { root: true })
        .then(authResponse => {
          if(authResponse.status == "SUCESSO") {
            return context.dispatch('concluirCriacaoPerfilAtendimento', payload);
          }
        }).catch((error) => {
          throw error;
        });
      default:
        return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarImoveisAtendimento(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_GRAVAR_IMOVEIS, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarImoveisAtendimento', payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarVisita(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_GRAVAR_VISITA, payload)
    .then((response) => {
       switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarVisita', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarAvaliacaoVisita(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_GRAVAR_AVALIACAO_VISITA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarAvaliacaoVisita', payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarImoveisSemelhantes(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_LISTAR_IMOVEIS_SEMELHANTES, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarImoveisSemelhantes', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarClientesSelect(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaClientesSelect', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarClientesSelect', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },
  gerarProposta(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_GERAR_PROPOSTA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('gerarProposta', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  enviarPropostaAssinatura(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_ENVIAR_PROPOSTA_ASSINATURA, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item);
          //context.commit('atualizarPropostaAguardandoAssinatura', response.data.item.propostas);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('enviarPropostaAssinatura', payload);
            }
          }).catch(error =>{
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  concluirProposta(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_CONCLUIR_PROPOSTA_MANUALMENTE, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item);
          context.commit('atualizarPropostaConcluida', response.data.item.propostas);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('concluirProposta', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  removerAtendimento(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_REMOVER, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerAtendimento', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  cancelarAtendimento(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_CANCELAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarAtendimento', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  cancelarAssinaturaProposta(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_CANCELAR_ASSINATURA_PROPOSTA, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item);
          //context.commit('atualizarPropostaAguardandoAssinatura', response.data.item.propostas);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarAssinaturaProposta', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  atualizarPreCadastro(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_ATUALIZAR_PRE_CADASTRO, payload) 
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('atualizarPreCadastro', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  atualizarCriacaoPerfil(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_ATUALIZAR_CRIACAO_PERFIL, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAtendimentoSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('atualizarCriacaoPerfil', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  enviarPropostaManualmente(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_ENVIAR_PROPOSTA_MANUAL)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('enviarPropostaManualmente', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  removerImovelSemelhante(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_REMOVER_IMOVEL_SEMELHANTE, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('removerImovelSemelhante', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  gerarPropostaManual(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_GERAR_PROPOSTA_MANUAL, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('gerarPropostaManual', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  cancelarProposta(context, payload) {
    return axios.post(URLS.ATENDIMENTOS_CANCELAR_PROPOSTA, {...payload, index: undefined})
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaPropostaCancelada', payload.index)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('cancelarProposta', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  }
}

export default {
  state,
  mutations,
  actions
}